// src/api/userService.js ver 01
import { callCloudFunction } from './apiClient';

export const getUserProfile = async (email, token) => {
    // Use a query parameter for email
    return callCloudFunction('getUserProfile', 'GET', null, null, token, null, { queryParams: { email } });
};

export const addUserProfile = async (profileData, token) => {
    return callCloudFunction('addUserProfile', 'POST', profileData, null, token);
};

export const updateUserProfile = async (userId, profileData, token) => {
    // userId is passed as a query parameter for update
    return callCloudFunction('updateUserProfile', 'PUT', profileData, null, token, null, { queryParams: { id: userId } });
};